import { taxTabs } from "./tax-tabs";
import { components } from "./components";

export const fiscalData = {
	components,
	taxTabs,
	titlePage: "Datos Fiscales",
	titlesTabs: {
		taxCouvert: "Datos fiscales de cover",
		taxGroups: "Grupos fiscales de producto",
		taxProfiles: "Perfiles fiscales",
		minimumConsummation: "Consumo mínimo",
		recharge: "Recarga",
	},
};
